/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface ExperienceProfessionnelleFichierUploadDto
 */
export interface ExperienceProfessionnelleFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    idexperienceProfessionnelleFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    idexperienceProfessionnelle?: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExperienceProfessionnelleFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the ExperienceProfessionnelleFichierUploadDto interface.
 */
export function instanceOfExperienceProfessionnelleFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExperienceProfessionnelleFichierUploadDtoFromJSON(json: any): ExperienceProfessionnelleFichierUploadDto {
    return ExperienceProfessionnelleFichierUploadDtoFromJSONTyped(json, false);
}

export function ExperienceProfessionnelleFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceProfessionnelleFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idexperienceProfessionnelleFichier': !exists(json, 'idexperienceProfessionnelleFichier') ? undefined : json['idexperienceProfessionnelleFichier'],
        'idexperienceProfessionnelle': !exists(json, 'idexperienceProfessionnelle') ? undefined : json['idexperienceProfessionnelle'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function ExperienceProfessionnelleFichierUploadDtoToJSON(value?: ExperienceProfessionnelleFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idexperienceProfessionnelleFichier': value.idexperienceProfessionnelleFichier,
        'idexperienceProfessionnelle': value.idexperienceProfessionnelle,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

